import React, { createContext, useReducer } from 'react';

import { GlobalStateReducer, initialState } from '../reducers/GlobalStateReducer';

import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";

export const GlobalStateContext = createContext();

const GlobalStateContextProvider = ({children}) => {
    const [globalState, dispatchGlobal] = useReducer(GlobalStateReducer, initialState);
    const setAsyncError = (asyncError) => {
        dispatchGlobal({
            type: 'SET_ASYNC_ERROR',
            data: {
                asyncError
            }
        });
    };
    const restartApp = () => {
        dispatchGlobal({
            type: 'RESTART_APP'
        });
    };
    const showWarning = (msg, callBack) => {
        dispatchGlobal({
            type: 'SET_WARNING',
            data: {
                warningMsg: msg,
                warningAction: callBack
            }
        });
    }
    const onCloseModal = () => {
        dispatchGlobal({
            type: 'SET_WARNING',
            data: {
                warningMsg: '',
                warningAction: () => {}
            }
        });
    }
    const value = {
        ...globalState,
        setAsyncError,
        restartApp,
        showWarning
    };
    return <GlobalStateContext.Provider value={value}>
        {children}
        <Modal
            title="Warning"
            open={globalState.warningMsg}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
        >
            <Text>{globalState.warningMsg}</Text>
            <ModalFooter>
                <Row alignmentHorizontal="end" widths="fit">
                    <Button type="tertiary" size="small" onClick={onCloseModal}>
                        Cancel
                    </Button>
                    <Button type="primary" size="small" onClick={() => {
                        globalState.warningAction();
                        onCloseModal();
                    }}>
                        Confirm
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    </GlobalStateContext.Provider>;
};

export default GlobalStateContextProvider;



// WEBPACK FOOTER //
// ./src/components/global/context/GlobalStateContext.js